import React from 'react';
import PropTypes from 'prop-types';
import { useBreakpointValue } from '@chakra-ui/react';
import ToggleDropDownMenu from './toggleDropDownMenu';
import HoverDropDownMenu from './hoverDropDownMenu';

const DropDownMenu = ({ onClickCallback, children, ...rest }) => {
  const isSmallerDevice = useBreakpointValue({ base: true, lg: false });
  const Container = isSmallerDevice ? ToggleDropDownMenu : HoverDropDownMenu;
  const props = isSmallerDevice ? { onClickCallback } : {};

  return (
    <Container {...props} {...rest}>
      {children}
    </Container>
  );
};

DropDownMenu.propTypes = {
  children: PropTypes.node,
  onClickCallback: PropTypes.func,
};

DropDownMenu.defaultProps = {
  children: null,
  onClickCallback: null,
};

export default DropDownMenu;
